// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__35Uq_","rootCenter":"LoadMoreObserver_rootCenter__35y5W","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3GVfS"};